import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddSmmDomain} from "./FormAddSmmDomain";

export const PanelAddSmmDomain = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Smm Domain</div>
          </div>
        }
      />
      <PanelBody content={<FormAddSmmDomain />} />
    </div>
  );
};
